import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import Pagination from "components/Common/newPagination";
import FormatReleaseUpsert from "./upsert/FormatReleaseUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function FormatReleasePage(param: any) {

  var payload = { pageNumber: 1, pageSize: 10 }
  let [formatReleaseCount, setformatReleaseCount] = useState<number>(0);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [formatReleaseListing, SetFormatReleaseListing] = useState<any>([]);

  useEffect(() => {
    if (param.activeTab === "Format Release") {
      formatReleaseSelect()
    }
  }, [param])

  const formatReleaseSelect = () => {
    formatReleaseCount = 0
    setformatReleaseCount(formatReleaseCount)

    systemListingService.FormatReleaseListing(payload).then((res: any) => {
      SetFormatReleaseListing(res);
      formatReleaseCount = res && res[0].totalRows ? res[0].totalRows : 0
      console.log(res[0].totalRows)
      console.log(formatReleaseCount)
      setformatReleaseCount(formatReleaseCount)
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payload.pageNumber = e.pageNumber;
    payload.pageSize = e.pageSize;
    formatReleaseSelect()
  }

  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }


  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deleteFormatRelease(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Format Release delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  return (

    <div className="content-card ws-12">

      <div className="ws-12">
        <div className="card-title">Format Release</div>

        <div className="ws-12 mb">
          <span className="pt mt pull-left">{formatReleaseCount} record(s) found </span>
          <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>
        </div>

        <div className="ws-12 mb">
          <button className="icon-btn primary fill pull-right" type="button" onClick={() => openAddDrawer({})}>Add Release </button>
        </div>

      </div>

      <div className="ws-12">

        {formatReleaseCount > 0 && <table className={editingOn ? "editing-on newTable" : "newTable"}>
          <thead>
            <tr>
              <th className="col-release-number">Release Number</th>
              <th className="col-release-desc">Release Description </th>
              <th style={{ width: 120, textAlign: "center" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {formatReleaseListing.map((row: any) => (
              <tr key={row.number}>
                <td className="col-release-number">{row.relNum}</td>
                <td className="col-release-desc">  {row.releaseDesc}  </td>
                <td style={{ width: "10%" }}>
                  <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }} className="width140">

                    <button className="icon-btn edit" title="Edit " type="button" disabled={!editingOn} onClick={() => openAddDrawer(row)}>
                      <i className="icon-pencil"></i>
                    </button>

                    <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}>
                      <i className="icon-trash"> </i>
                    </button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>}

        {formatReleaseCount === 0 && <div className="alert alert-info ws-12 box" >No records to display</div>}

        {formatReleaseCount > 10 && <div className="ws-10">
          <Pagination totalRow={formatReleaseCount} onPageChange={onPageChange} />
        </div>}
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <FormatReleaseUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected format release " + deleteData?.releaseDesc} onChange={deleteConfirmation} />
          }
        })()
      }

    </div>

  );
}; 